import { render, staticRenderFns } from "./healthInfoList.vue?vue&type=template&id=bc3d2af6&scoped=true"
import script from "./healthInfoList.vue?vue&type=script&lang=js"
export * from "./healthInfoList.vue?vue&type=script&lang=js"
import style0 from "./healthInfoList.vue?vue&type=style&index=0&id=bc3d2af6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3d2af6",
  null
  
)

export default component.exports